// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"f346081b","237":"b8825b7d","396":"0efd0dc0","453":"2d6d3f60","507":"03528d43","546":"345fc175","599":"52930e91","705":"537c65c8","776":"80bc79a1","959":"789fdf96"}[chunkId] + ".chunk.js";
};